import { render, staticRenderFns } from "./CryptoSection.vue?vue&type=template&id=749d3696"
import script from "./CryptoSection.vue?vue&type=script&lang=js"
export * from "./CryptoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports